import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.text.primary,
    marginLeft: "15px",
  },
  sequencePageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  SequenceListItem: {
    padding: "1px",
    overflow: "hidden",
    borderCollapse: "collapse",
    width: "15%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  SequenceListItemTwo: {
    padding: "1px",
    overflow: "hidden",
    borderCollapse: "collapse",
    width: "15%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  SequenceListItemThree: {
    padding: "1px",
    overflow: "hidden",
    borderCollapse: "collapse",
    width: "10%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
}));

export default useStyles;
